import { Skeleton } from 'breeze-intelligence-kit';
// Refer to https://hubspot.slack.com/archives/C06V7LMDN48/p1753205196129099
// bend-lint-disable-next-line strict-exports
import { useGetRecordLink } from 'crm-links/record/useGetRecordLink';
import { getObjectTypeIconComponent } from 'customer-data-objects-ui-components/objects/getObjectTypeIconComponent';
import { CRM_OBJECT } from 'customer-data-objects/externalOptions/ExternalOptionsReferenceTypes';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import unescapedText from 'I18n/utils/unescapedText';
import { useEffect, useState } from 'react';
import ReferenceLiteName from 'reference-resolvers-lite/components/ReferenceLiteName';
import { useObjectTypeDefinition } from '../../ObjectTypeDefinitionsProvider/useObjectTypeDefinition';
import { usePropertyDefinition } from '../../PropertyDefinitionsProvider/usePropertyDefinition';
import { jsx as _jsx } from "react/jsx-runtime";
export const CrmDataSourceButton = ({
  children,
  source
}) => {
  const {
    objectId,
    objectTypeId,
    propertyName
  } = source;
  const {
    objectTypeDefinition,
    isLoading: isObjectTypeDefinitionLoading
  } = useObjectTypeDefinition(source.objectTypeId);
  const {
    propertyDefinition,
    isLoading: isPropertyDefinitionLoading
  } = usePropertyDefinition(propertyName);
  const [href, setHref] = useState();
  const getRecordLink = useGetRecordLink();
  useEffect(() => {
    getRecordLink({
      objectId,
      objectTypeId
    }).then(link => {
      setHref(link === null || link === void 0 ? void 0 : link.href);
    }).catch(() => {});
  }, [getRecordLink, objectId, objectTypeId]);
  const renderWithReference = result => {
    var _propertyDefinition$p;
    const reference = 'reference' in result ? result.reference : undefined;
    const {
      singularForm
    } = objectTypeDefinition !== null && objectTypeDefinition !== void 0 ? objectTypeDefinition : {};
    const {
      label
    } = (_propertyDefinition$p = propertyDefinition === null || propertyDefinition === void 0 ? void 0 : propertyDefinition.property) !== null && _propertyDefinition$p !== void 0 ? _propertyDefinition$p : {};
    const primaryText = singularForm !== null && singularForm !== void 0 ? singularForm : unescapedText('citation.sourcesList.crmDataRecordFallbackLabel');
    const referenceLabelText = reference !== null && reference !== void 0 && reference.label ? `${reference === null || reference === void 0 ? void 0 : reference.label}` : '';
    const propertyLabelText = label ? `(${label})` : '';
    const secondaryText = `${referenceLabelText} ${propertyLabelText}`.trim();
    const IconComponent = getObjectTypeIconComponent(objectTypeId);
    const disabled = !href;
    return children({
      primaryText,
      secondaryText,
      disabled,
      href,
      icon: /*#__PURE__*/_jsx(IconCircle, {
        backgroundColor: "fill-primary-default",
        borderWidth: "0",
        color: "icon-primary-default",
        icon: IconComponent,
        padding: "100",
        size: "100"
      })
    });
  };
  const renderLoading = () => /*#__PURE__*/_jsx(Skeleton, {
    variant: "breeze",
    blockSize: "39px"
  });
  if (isObjectTypeDefinitionLoading || isPropertyDefinitionLoading) {
    return renderLoading();
  }
  return /*#__PURE__*/_jsx(ReferenceLiteName, {
    id: String(objectId),
    objectTypeId: objectTypeId,
    referenceType: CRM_OBJECT,
    renderLoading: renderLoading,
    renderSuccess: renderWithReference,
    renderError: renderWithReference,
    renderObjectNotFound: renderWithReference,
    renderObjectArchived: renderWithReference
  });
};